"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 21a9 9 0 0 1-3.445-.69 8.94 8.94 0 0 1-4.87-4.87c-1.898-4.583.286-9.856 4.87-11.755s9.86.286 11.76 4.87c1.899 4.582-.286 9.856-4.872 11.755-1.11.46-2.277.69-3.443.69M9.092 4.978c-3.871 1.604-5.716 6.057-4.113 9.927a7.55 7.55 0 0 0 4.113 4.112 7.55 7.55 0 0 0 5.816 0c3.873-1.603 5.717-6.056 4.114-9.926-1.605-3.87-6.059-5.716-9.93-4.113m4.922 10.634h-.031a.95.95 0 0 1-.859-.616l-1.68-4.481-.797 1.77a.7.7 0 0 1-.639.413h-2.99a.7.7 0 1 1 0-1.4h2.537l1.06-2.354a.95.95 0 0 1 .897-.56.95.95 0 0 1 .859.616l1.68 4.481.798-1.77a.7.7 0 0 1 .638-.413h1.495a.7.7 0 1 1 0 1.4H15.94l-1.06 2.354a.95.95 0 0 1-.866.56"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ActivityIcon24.js.map